import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import { Events } from 'constants';

import RestaurantMenuAction from 'actions/RestaurantMenuAction';

import { RestaurantMenuStore } from 'stores';

// -- utils
import SecurityContext from 'utils/permissions/SecurityContext';
import Notify from 'PMT/utils/Notify';
import Utils from 'PMT/utils/Utils';

// -- entities
import {
  RestaurantMenu,
  UpsellingCategory
} from 'PMT/entities/menu';

// -- views
import AbstractRestaurantMenuComponent from '../../components/AbstractRestaurantMenuComponent';
import FixedSubmitArea from 'PMT/components/form/FixedSubmitArea';
import UpsellingCategoryRow from './components/UpsellingCategoryRow';
import RoundButton from 'components/RoundButton';
import SortableList from 'PMT/components/SortableList';
import EditUpsellingCategoryModal from 'components/restaurantMenu/upsellingCategoryModal/EditUpsellingCategoryModal';

export default class UpsellingCategoriesListPage extends AbstractRestaurantMenuComponent {

  state = {
    ...this.getDefaultState(),
    ...{
      displayEditCategoryModal: false,
    }
  }

  componentDidMount() {
    RestaurantMenuStore.addListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onUpdateRestaurantMenuSuccess);
  }

  componentWillReceiveProps(nextProps: Object) {
    if (!nextProps.restaurantMenu.equals(this.props.restaurantMenu)) {
      this.setState({
        restaurantMenu: nextProps.restaurantMenu.copy()
      });
    }
  }


  onUpdateRestaurantMenuSuccess = () => {
    this.setState({
      loading: false
    });
  };

  //
  //
  //

  onAddCategoryClick = () => {
    this.setState({
      displayEditCategoryModal: true,
    })
  };

  hideEditCategoryModal = () => {
    this.setState({
      displayEditCategoryModal: false,
    })
  }

  onOrderChange = (items) => {
    const restaurantMenu: RestaurantMenu = this.restaurantMenu;

    restaurantMenu.categories = items

    this.setState({
      restaurantMenu
    });
  };

  onToggleActivationUpsellingCategory = (category: UpsellingCategory) => {
    if (SecurityContext.restaurantMenu.canEdit()) {
      const restaurantMenu: RestaurantMenu = this.restaurantMenu;
      category.enabled = !category.enabled;

      restaurantMenu.toggleUpsellingCategory(category);

      this.setState({
        restaurantMenu
      });
    }
  };

  onDeleteUpsellingCategory = (category: UpsellingCategory) => {
    Notify.confirm(I18n.tr('menu.upselling_category.confirm_deletion'), (result) => {
      if (result) {
        const restaurantMenu: RestaurantMenu = this.restaurantMenu;

        restaurantMenu.removeUpsellingCategory(category);

        this.setState({
          restaurantMenu
        });
      }
    });
  };

  //
  // getters
  //

  get restaurantMenu(): RestaurantMenu {
    return this.state.restaurantMenu;
  }

  haveModifications() {
    return !this.state.restaurantMenu.equals(this.props.restaurantMenu);
  }

  //
  // renderers
  //
  renderEditModal() {
    const newUpsellingCategory = new UpsellingCategory()
    newUpsellingCategory.id = Utils.generateUID();

    return (
      <EditUpsellingCategoryModal
        isEdit={false}
        upsellingCategory={newUpsellingCategory}
        onUpdate={upsellingCategory => {
          const restaurantMenu: RestaurantMenu = this.restaurantMenu;
          restaurantMenu.addUpsellingCategory(upsellingCategory);
          this.setState({
            restaurantMenu
          }, () => {
            // when we add a category, we want to click on it to add products, but it fails if the
            // category isn't on the store. So we save it.
            this.onSubmit();
          });
        }}
        show={this.state.displayEditCategoryModal}
        onHide={this.hideEditCategoryModal}
      />
    )
  }

  renderHeader() {
    if (!SecurityContext.restaurantMenu.canEdit()) {
      return (null);
    }

    if (_.isEmpty(this.restaurantMenu.products)) {
      return (
        <p className="bg-warning">
          {I18n.tr('menu.upselling_category.error_no_products_exists')}
        </p>
      );
    }

    return (
      <div className="row">
        <div className="col-xs-12">
          <div className="alert alert-info">
            {I18n.tr('menu.upselling_category.caption')}
          </div>
        </div>
        <div className="col-sm-12 col-md-6">
          <RoundButton
            text={I18n.tr('menu.upselling_category.add_category')}
            onClick={this.onAddCategoryClick}
          />
        </div>
      </div>
    );
  }

  renderTheadContent() {
    return (
      <div className="thead">
        <div className="col-xs-8 col-sm-4">
          {I18n.tr('menu.upselling_category.table.header.name')}
        </div>

        <div className="hidden-xs col-sm-4">
          {I18n.tr('menu.upselling_category.table.header.description')}
        </div>

        <div className="hidden-xs col-sm-2">
          {I18n.tr('menu.upselling_category.table.header.enabled')}
        </div>

        {SecurityContext.restaurantMenu.canEdit() &&
          <div className="col-xs-1">
            {I18n.tr('menu.upselling_category.table.header.delete')}
          </div>
        }

        {SecurityContext.restaurantMenu.canEdit() &&
          <div className="col-xs-1 text-center">
            {I18n.tr('menu.upselling_category.table.header.move')}
          </div>
        }
      </div>
    );
  }

  renderRow = (upsellingCategory: UpsellingCategory) => {
    return (
      <UpsellingCategoryRow
        upsellingCategory={upsellingCategory}
        restaurantMenu={this.restaurantMenu}
        key={upsellingCategory.name}
        onDeleteUpsellingCategory={this.onDeleteUpsellingCategory}
        onToggleActivationUpsellingCategory={this.onToggleActivationUpsellingCategory}
      />
    );
  };

  renderCategoriesListView() {
    return (
      <SortableList
        items={this.restaurantMenu.upsellingCategories}
        onChange={this.onOrderChange}
        renderer={this.renderRow}
        displayDragIcon={false}
      />
    );
  }

  render() {
    return (
      <div className="categories_list top-buffer-30">
        {this.renderHeader()}

        {!_.isEmpty(this.restaurantMenu.upsellingCategories) &&
          <div className="table_container table_container_hover top-buffer-50 row">
            {this.renderTheadContent()}
            {this.renderCategoriesListView()}
          </div>
        }

        {this.renderEditModal()}

        {SecurityContext.restaurantMenu.canEdit() &&
          this.renderFixedButtons()
        }
        {this.renderLoading()}
      </div>
    );
  }

}
